module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/ffa-emblem-1e62a78068276422199f0abd98eefdcc.webp";